import React from 'react'
import PropTypes from 'prop-types'
import FontSizeInput from 'letter/components/header/header_tools/font_size_input'
import FontFamilySelect from 'letter/components/header/header_tools/font_family_select'
import FontBoldControl from 'letter/components/header/header_tools/font_bold_control'
import FontUnderlineControl from 'letter/components/header/header_tools/font_underline_control'
import FontItalicControl from 'letter/components/header/header_tools/font_italic_control'
import ColorPicker from 'letter/components/header/header_tools/color_picker'

const HeaderFontTools = (props) => {
  const {
    canvas,
    fonts,
    textSelected,
    canHaveColor,
    textIsBold,
    textIsItalic,
    textIsUnderlined,
    selectedFont,
    textSupportsBold,
    textSupportsItalic,
    selectedFontColor,
    selectedFontSize,
    handleFontFamilyChange,
    handleFontSizeChange,
  } = props

  return (
    <div className={'letterHeaderFontTools'}>
      <div className='letterHeaderTools_fontStyle'>
        <FontBoldControl
          canvas={canvas}
          active={textIsBold}
          selectedFont={selectedFont}
          disabled={!textSupportsBold || !textSelected} />
        <FontUnderlineControl
          canvas={canvas}
          active={textIsUnderlined}
          disabled={!textSupportsBold || !textSelected} />
        <FontItalicControl
          canvas={canvas}
          active={textIsItalic}
          disabled={!textSupportsItalic || !textSelected} />
      </div>
      <FontFamilySelect
        canvas={canvas}
        value={selectedFont ? selectedFont.name : ''}
        disabled={!(textSelected)}
        fonts={fonts}
        onChange={handleFontFamilyChange} />
      <FontSizeInput
        canvas={canvas}
        visible={!(textSelected)}
        value={selectedFontSize}
        onChange={handleFontSizeChange} />
      <ColorPicker
        canvas={canvas}
        visible={canHaveColor || textSelected}
        value={selectedFontColor} />
    </div>
  )
}

HeaderFontTools.propTypes = {
  canvas: PropTypes.object,
  fonts: PropTypes.array,
  textSelected: PropTypes.bool,
  canHaveColor: PropTypes.bool,
  textIsBold: PropTypes.bool,
  textIsItalic: PropTypes.bool,
  textIsUnderlined: PropTypes.bool,
  textSupportsBold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]),
  textSupportsItalic: PropTypes.bool,
  selectedFont: PropTypes.object,
  selectedFontColor: PropTypes.string,
  selectedFontSize: PropTypes.number,
}

export default HeaderFontTools
